import type { ToolDefinition } from "../types";
import imageAnalyzerTool from "./image-analyzer";
import imageDpiCheckerTool from "./image-dpi-checker";
import aiPdfAnalysisTool from "./ai-pdf-analysis";
import imageAuthenticityCheckerTool from "./image-authenticity-checker";

export const analysisTools: ToolDefinition[] = [
  imageAnalyzerTool,
  imageDpiCheckerTool,
  imageAuthenticityCheckerTool,
  aiPdfAnalysisTool,
];

export { default as imageAnalyzerTool } from "./image-analyzer";
export { default as imageDpiCheckerTool } from "./image-dpi-checker";
export { default as aiPdfAnalysisTool } from "./ai-pdf-analysis";
export { default as imageAuthenticityCheckerTool } from "./image-authenticity-checker";
